export interface ToolError {
  type: 'error';
  name: string;
  message: string;
}

export const isToolError = (result: unknown): result is ToolError =>
  !!result &&
  typeof result === 'object' &&
  (result as { type?: unknown }).type === 'error';

/**
 * What a list-returning tool (keyword / semantic search) actually sent back.
 * The server types these as arrays, but the tool also returns a plain string
 * ("No results found for …"), `undefined`, or a `ToolError` on failure
 * (YOD-794: `.map` on an error object threw inside the chat render).
 */
export type ListToolResult<T> =
  | { kind: 'items'; items: T[] }
  | { kind: 'message'; message: string }
  | { kind: 'error' };

export function classifyListToolResult<T>(result: unknown): ListToolResult<T> {
  if (Array.isArray(result)) {
    return { kind: 'items', items: result as T[] };
  }
  if (typeof result === 'string') {
    return { kind: 'message', message: result };
  }
  if (result === undefined || result === null) {
    return { kind: 'items', items: [] };
  }
  return { kind: 'error' };
}
